import { Injectable } from '@angular/core';
import { Router } from '@angular/router';
import { Observable, of, switchMap, map, startWith } from 'rxjs';
import { PopoverService } from 'src/@vex/components/popover/popover.service';
import { AddTimeComponent } from '../examschedule-layout/add-time/add-time.component';
import { ChangeExamScheduleStartDateTimeComponent } from '../examschedule-layout/change-exam-schedule-start-date-time/change-exam-schedule-start-date-time.component';
import { ChangeExamStatusComponent } from '../examschedule-layout/change-exam-status/change-exam-status.component';
import { ConfirmExamScheduleRestartComponent } from '../examschedule-layout/confirm-exam-schedule-restart/confirm-exam-schedule-restart.component';
import { PauseCandidateExamComponent } from '../examschedule-layout/pause-candidate-exam/pause-candidate-exam.component';
import { RecomputeIssueScoreComponent } from '../examschedule-layout/recompute-issue-score/recompute-issue-score.component';
import { ExamScheduleService } from './exam-schedule-service';
import { SnackbarService } from './snackbar.service';
import { GenerateSebConfigComponent } from '../exam-layout/operations/generate-seb-config/generate-seb-config.component';
import { ExamService } from './exam-service.service';
import { id } from 'date-fns/locale';
import { ImportCandidatesDataComponent } from '../exam-layout/operations/ImportCandidatesData/ImportCandidatesData.component';
import { AddScheduleFlagsComponent } from '../examschedule-layout/add-schedule-flags/add-schedule-flags.component';
import { IExam } from '../interface/dto';
import { AutoMarkSAQComponent } from '../exam-layout/operations/auto-mark-saq/auto-mark-saq.component';

@Injectable({
  providedIn: 'root'
})
export class ExamScheduleOperationsService {

  opOpen$: Observable<boolean> = of(false);

  constructor(private popoverService: PopoverService, private router: Router, private examSchService: ExamScheduleService, private examService: ExamService, private snackBar: SnackbarService,) { }

  get opsList() {
    return [
      {
        icon: 'mat:restore_page',
        label: 'Restart Exam',
        route: 'operations/examschdule/restart',
        id: 'examinationschedules_restart_examination'
      },
      {
        icon: 'mat:add_alarm',
        label: 'Add Time',
        route: 'operations/examschdule/addtime',
        id: 'examinationschedules_add_time'
      },
      {
        icon: 'mat:pause_circle',
        label: 'Pause/Unpause Candidate Exam',
        route: 'operations/examschdule/pauseunpauseexam',
        id: 'examinationschedules_pause_unpause_candidate_exam'
      },
      {
        icon: 'mat:flag',
        label: 'Flag Candidate',
        route: 'operations/examschdule/flags',
        id: 'flag_examinationschedule'
      },
      {
        icon: 'mat:toggle_off',
        label: 'Change Status',
        route: 'operations/examschdule/changeStatus',
        id: 'examinationschedules_change_status'
      },
      {
        icon: 'mat:published_with_changes',
        label: 'Change Examination Schedule Start Date/Time',
        route: 'operations/examschdule/changeexamschedule',
        id: 'examinationschedules_change_examination_schedule_start_date_time'
      },
      {
        icon: 'mat:build_circle',
        label: 'Recompute Network Availability Score',
        route: 'operations/examschdule/recomputeissuescore',
        id: 'examinationschedules_recompute_network_availability_score'
      },
      {
        icon: 'mat:create_new_folder',
        label: 'Generate SEB Config',
        route: 'operations/examschdule/generatesebconfig',
        id: 'examinationschedules_generate_seb_config'
      },
      {
        icon: 'mat:create_new_folder',
        label: 'Import Candidate data',
        route: 'operations/examschdule/import_candidates_data',
        id: 'examinationschedules_import_candidates_exam_data'
      },
      {
        icon: 'mat:brightness_auto',
        label: 'Auto Mark SAQ',
        route: 'operations/examschdule/autoMarkSAQ',
        id: 'examinationschedules_auto_mark_saq'
      }
      ,
      {
        icon: 'mat:playlist_add_check',
        label: 'Mark SAQ',
        route: 'operations/exam/markSaq',
        id: 'examinationschedules_mark_saq_exam'
      }
      ,
      {
        icon: 'mat:playlist_add_check',
        label: 'Mark Essay',
        route: 'operations/exam/markEssay',
        id: 'examinationschedules_mark_essay_exam'
      },
      {
        icon: 'mat:playlist_play',
        label: 'View Examination Recordings',
        route: 'operations/exam/recordings',
        id: 'examinations_proctors'
      }
    ];
  }

  async processOperation(route: any, origin: any) {
    let selectedExamID = this.examService.selectedExamIds[0];
    let selectedExam = this.examService.selectedExams[0];
    let selectedSchID = this.examSchService.selectedSchedules[0].id;
    let examID = this.examSchService.selectedSchedules[0].examinationID;
    if (!selectedExamID || !selectedExam && !examID) {
      selectedExam = await this.examService.getExamById(examID) as IExam;
    }

    if (route === 'operations/examschdule/restart') {
      this.confirmExamScheduleRestart(origin);
      return;
    }
    if (route === 'operations/examschdule/recomputeissuescore') {
      this.recomputeIssueScore(origin);
      return;
    }
    if (route === 'operations/examschdule/addtime') {
      this.addTime(origin);
      return;
    }
    if (route === 'operations/examschdule/pauseunpauseexam') {
      this.pauseUnpauseExam(origin);
      return;
    }

    if (route === 'operations/examschdule/changeStatus') {
      this.changeStatus(origin);
      return;
    }
    if (route === 'operations/examschdule/changeexamschedule') {
      // this.changeExamSchedule(origin);
      this.router.navigate([`exams/${selectedExamID}/schedules/${selectedSchID}/changeexamscheduledtartdatetime`]);

      return;
    }
    if (route === 'operations/examschdule/generatesebconfig') {
      this.generateSEBConfig(origin);
    }
    if (route === 'operations/examschdule/import_candidates_data') {
      this.openPopup(origin, ImportCandidatesDataComponent);
    }
    if (route.match("operations/exam/import_candidates_data")) {
      this.openPopup(origin, ImportCandidatesDataComponent);
    }

    if (route.match("operations/examschdule/autoMarkSAQ")) {
      if (selectedExam.examinationTypeenum != "SAQ") {
        this.snackBar.warning('SAQ Exam Not Selected');
        return;
      }

      if (selectedExam.enableAIMarking) {
        this.openPopup(origin, AutoMarkSAQComponent);
        return;
      }

      let data = { ExaminationScheduleID: selectedSchID, ExaminationID: selectedExamID };
      await this.examService.autoMarkSAQ(data).then((res: any) => {
        this.snackBar.success('Auto Marked SAQ Exams Successfull');
      });
    }

    if (route.match("operations/examschdule/flags")) {
      this.openPopup(origin, AddScheduleFlagsComponent);
    }
    if (route.match("operations/exam/markSaq")) {
      if (selectedExam.examinationTypeenum != "SAQ") {
        this.snackBar.warning('SAQ Exam Not Selected');
        return;
      }
      this.router.navigate([`exams/${selectedExamID}/marksaq`]);
    }
    if (route.match("operations/exam/markEssay")) {
      if (selectedExam.examinationTypeenum != "Essay") {
        this.snackBar.warning('Essay Exam Not Selected');
        return;
      }
      this.router.navigate([`exams/${selectedExamID}/markessay`]);
    }
    if (route == 'operations/exam/recordings') {
      this.router.navigate([`exams/${selectedExamID}/recordings`]);
    }

  }

  confirmExamScheduleRestart(origin) {
    this.openPopup(origin, ConfirmExamScheduleRestartComponent);
  }

  recomputeIssueScore(origin) {
    this.openPopup(origin, RecomputeIssueScoreComponent);
  }

  addTime(origin) {
    this.openPopup(origin, AddTimeComponent);
  }

  pauseUnpauseExam(origin) {
    this.openPopup(origin, PauseCandidateExamComponent);
  }

  changeStatus(origin) {
    this.openPopup(origin, ChangeExamStatusComponent);
  }

  changeExamSchedule(origin) {
    this.openPopup(origin, ChangeExamScheduleStartDateTimeComponent);
  }

  async generateSEBConfig(origin: any) {
    this.opOpen$ = of(
      this.popoverService.open({
        content: GenerateSebConfigComponent,
        origin,
        width: 2000,
        offsetY: 12,
        position: [
          {
            originX: 'end',
            originY: 'bottom',
            overlayX: 'end',
            overlayY: 'bottom'
          }, {
            originX: 'end',
            originY: 'bottom',
            overlayX: 'end',
            overlayY: 'bottom'
          }
        ]
      })
    ).pipe(
      switchMap(popoverRef => popoverRef.afterClosed$.pipe(map(() => false))),
      startWith(true),
    );
  }

  openPopup(origin: any, component: any) {
    this.opOpen$ = of(
      this.popoverService.open({
        content: component,
        origin,
        width: 2000,
        offsetY: 12,
        position: [
          {
            originX: 'end',
            originY: 'center',
            overlayX: 'end',
            overlayY: 'center'
          }, {
            originX: 'end',
            originY: 'center',
            overlayX: 'end',
            overlayY: 'center'
          }
        ]
      })
    ).pipe(
      switchMap(popoverRef => popoverRef.afterClosed$.pipe(map((x) => false))),
      startWith(true),
    );
  }
}
